/* unplugin-vue-components disabled */import { render } from "./teacherAndCourse.vue?vue&type=template&id=c528f536&scoped=true"
import script from "./teacherAndCourse.vue?vue&type=script&lang=js"
export * from "./teacherAndCourse.vue?vue&type=script&lang=js"

import "./teacherAndCourse.vue?vue&type=style&index=0&id=c528f536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c528f536"]])

export default __exports__